import { GET_HISTORY_SUCCESS, GET_STAFF_HISTORY_SUCCESS } from './history.type';

const initialState = {
    history: [],
    staffHistory: [],
};

export const historyReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_HISTORY_SUCCESS:
            return {
                ...state,
                history: action.payload.history,
            };

        case GET_STAFF_HISTORY_SUCCESS:
            return {
                ...state,
                staffHistory: action.payload.history,
            };

        default:
            return state;
    }
};
